"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const styles = (theme) => (0, styles_1.createStyles)({
    container: material_kit_pro_react_1.container,
    gridContainer: {
        [theme.breakpoints.up('md')]: {
            paddingTop: 0
        }
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    centered: {
        alignItems: 'center'
    },
    spaceBetween: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    row: {
        display: 'flex',
        flexDirection: 'row'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
    card: {
        height: 'max-content',
        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(3)
        }
    },
    detailsContainer: {
        flex: 1
    },
    detailsContent: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    },
    details: {
        backgroundColor: color(theme.palette.primary.dark).alpha(0.7).rgb().string(),
        padding: theme.spacing(3),
        marginLeft: theme.spacing(4),
        borderRadius: 10
    },
    detailsLower: {
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginTop: theme.spacing(3)
        }
    },
    detailsUpper: {
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(2),
            marginLeft: theme.spacing(2),
            marginBottom: 0
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0
        }
    },
    firstSection: {
        width: '100%',
        marginTop: theme.spacing(),
        [theme.breakpoints.down('md')]: {
            marginTop: theme.spacing(2)
        }
    },
    drawInfo: {
        backgroundColor: color(theme.palette.common.black).alpha(0.3).rgb().string(),
        padding: theme.spacing(3),
        borderRadius: 6,
        width: '100%',
        marginTop: theme.spacing(),
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        }
    },
    drawDate: {
        backgroundColor: color(theme.palette.common.black).alpha(0.6).rgb().string(),
        padding: theme.spacing(2),
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6,
        width: '100%',
        marginBottom: theme.spacing(2.5),
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing()
        }
    },
    media: {
        height: 492,
        width: 492,
        [theme.breakpoints.down('lg')]: {
            height: 422,
            width: 422
        },
        [theme.breakpoints.down('md')]: {
            height: 340,
            width: 340
        },
        [theme.breakpoints.down('xs')]: {
            height: 384,
            width: '100%'
        }
    },
    link: {
        textDecoration: 'underline',
        cursor: 'pointer'
    },
    spacing: {
        marginBottom: theme.spacing(4)
    },
    btnLeft: {
        marginBottom: theme.spacing(3),
        marginRight: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            marginRight: 0
        }
    },
    btnRight: {
        marginBottom: theme.spacing(3),
        marginLeft: theme.spacing(1.5),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0
        }
    },
    btnContainer: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    },
    tokens: {
        marginBottom: theme.spacing(3.6),
        [theme.breakpoints.down('lg')]: {
            marginBottom: theme.spacing(2)
        }
    },
    token: {
        marginRight: theme.spacing()
    },
    descriptionTitle: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    buttonStyle: {
        '&,&:hover,&:focus': {
            color: `${theme.palette.secondary.main} !important`
        },
        '&:hover,&:focus': {
            zIndex: 3,
            backgroundColor: 'rgba(0,0,0,0.3)',
            borderColor: theme.palette.secondary.main
        },
        '&.Mui-disabled': {
            color: `${color(theme.palette.secondary.main).alpha(0.4).rgb().string()} !important`
        }
    },
    pastDrawStyle: {
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: 20
        }
    },
    noWinnerText: {
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
            textAlignLast: 'left'
        }
    },
    pastDrawTableStyle: {
        marginBottom: theme.spacing(5)
    },
    pastDrawGrid: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(3)
    },
    pastDrawTable: {
        textAlignLast: 'center',
        width: '50%'
    },
    historyCell: {
        padding: theme.spacing(3),
        textAlignLast: 'right'
    },
    pastDrawSignIn: {
        textAlignLast: 'center',
        padding: theme.spacing(3)
    },
    button: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        color: `${theme.palette.primary.dark} !important`,
        boxShadow: '0 0 10px 0 #b3b9ff',
        borderColor: 'transparent',
        '&.Mui-disabled': {
            borderColor: 'transparent',
            backgroundColor: 'rgba(0, 0, 0, 0.12) !important',
            boxShadow: 'none'
        },
        '&:hover': {
            boxShadow: '0 0 10px 1px #b3b9ff',
            backgroundColor: '#e3d0a0'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=RewardsScreenStyle.js.map